module.exports = __webpack_public_path__ + "img/icons BFr_11.3c688e35.svg";